import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapState } from 'vuex';

const defaultEl = {
  id: null,
  workplace_id: '',
  job_id: '',
  amount: ''
};

export default {
  name: 'WorkplaceRequirementEdit',
  data () {
    return {
      editEl: defaultEl,
      workplace: {},
      isLoading: false
    }
  },
  validations: {
    editEl: {
      workplace_id: { required },
      job_id: { required },
      amount: { required }
    }
  },
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['config']),
    jobOptions () {
      const options = this.$store.getters.getConfigOptions('company_jobs', this.$i18n.locale, null, null, false, false, false, ['job_positions']).filter(
        el => {
          const positions = Object.values(el.job_positions);
          for (const pos of positions) {
            if (this.workplace.department_id == parseInt(pos.department_id)) {
              if (this.workplace.division_id) {
                if (this.workplace.division_id == parseInt(pos.division_id)) {
                  return true;
                }
                continue;
              }
              return true;
            }
          }
          return false;
        }
      );

      return this.BasicHelper.sortArrayByKeyValue(options, 'sortText');
    },
    baseTransParam () {
      return 'workplace.requirements';
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t(`${this.baseTransParam}.actions.edit`);
      }
      return this.$t(`${this.baseTransParam}.actions.new`);
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    show (elData, workplace) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }

      this.workplace = workplace;
      this.editEl.workplace_id = workplace.id;

      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }

        const path = 'ezuro/workplaces/requirements/save';

        this.ApiRequest.request(path + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$store.dispatch('reloadConfig');
            this.$emit('saved', response.data);
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
